export default {"src":"/_next/static/media/Success.1ed2fe2c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};